import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M19.731 8.81868C19.6153 8.90869 17.5713 10.0628 17.5713 12.6291C17.5713 15.5974 20.1722 16.6475 20.25 16.6735C20.238 16.7375 19.8368 18.1116 18.8787 19.5118C18.0244 20.7439 17.1321 21.974 15.7748 21.974C14.4175 21.974 14.0682 21.1839 12.5013 21.1839C10.9743 21.1839 10.4313 22 9.18978 22C7.94823 22 7.08193 20.8599 6.08589 19.4597C4.93216 17.8156 4 15.2613 4 12.8371C4 8.94869 6.52303 6.88649 9.00614 6.88649C10.3255 6.88649 11.4254 7.75458 12.2537 7.75458C13.0422 7.75458 14.2718 6.83448 15.7728 6.83448C16.3417 6.83448 18.3857 6.88649 19.731 8.81868ZM15.0602 5.18832C15.681 4.45024 16.1201 3.42614 16.1201 2.40204C16.1201 2.26003 16.1082 2.11601 16.0822 2C15.0722 2.038 13.8706 2.67407 13.146 3.51615C12.5771 4.16422 12.0462 5.18832 12.0462 6.22642C12.0462 6.38244 12.0721 6.53845 12.0841 6.58846C12.148 6.60046 12.2518 6.61446 12.3555 6.61446C13.2618 6.61446 14.4015 6.0064 15.0602 5.18832Z",
      fill: "black"
    }, null, -1)
  ])))
}
export default { render: render }